import { ROLE_DATA, sortedByRoleBadge } from './roles.js';

export const SPECIAL_ROLE_IDS = [
  "witch","protector","hunter","cupid","flute_player","father_of_wolves",
  "angel","bear_tamer","big_bad_wolf","little_girl","raven","seer","thief",
  "elder","white_werewolf","wild_child","fox","shepherd",
];

export const DEFAULT_NIGHT_ROLE_ORDER = [
  "thief","cupid","wild_child","seer","fox","protector","shepherd",
  "werewolf","father_of_wolves","big_bad_wolf",
  "witch","flute_player","raven","white_werewolf",
  // Passive — listed for completeness in settings UI; filtered at runtime
  "villager","little_girl","bear_tamer","hunter","angel","elder",
];

// Raw catalog groupings — sorted by roleBadge (new first, experimental last)
const RAW_CATALOG = {
  village:  ["villager","witch","protector","hunter","cupid","seer","raven","bear_tamer","little_girl","elder","fox","shepherd"],
  werewolf: ["werewolf","father_of_wolves","big_bad_wolf"],
  solo:     ["flute_player","white_werewolf"],
  mixed:    ["angel","wild_child","thief"],
};

export const CATALOG_CATEGORIES = Object.fromEntries(
  Object.entries(RAW_CATALOG).map(([k, ids]) => [k, sortedByRoleBadge(ids)])
);

export const DEFAULT_SETTINGS = {
  mayorEnabled: true,
  witchPoisonOnNight1: false,
  fatherInfectionOnNight1: false,
  muteSeer: false,
  flutePlayerConstantCount: true,
  flutePlayerCharmsPerNight: 2,
  nightRoleOrder: null,
  shepherdSheepCount: 3,
};
